import { adminAPIService, goxipAPIService } from './index'

const route = 'members'

export const checkEmailAvailability = (email) => {

  return new Promise((resolve, reject) => {
    goxipAPIService({
      url: `v3/newhope-admin/${route}/email/${email}`,
      method: 'get',
    }).then((result)=>{
      if (result.data.data == true) {
        resolve()
      }
      reject('MEMBER_EMAIL_EXIST')
    })
  })
}

export const checkUsernameAvailability = (username) => {

  return new Promise((resolve, reject) => {
    goxipAPIService({
      url: `v3/newhope-admin/${route}/username/${username}`,
      method: 'get',
    }).then((result)=>{
      if (result.data.data == true) {
        resolve()
      }
      reject('MEMBER_USERNAME_EXIST')
    })
  })
}